var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["intl-shipping-information-table.j2"] = require( "intl-shipping-information-table.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/eu-shipping-information-table.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"dom-intl-shipping\">\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12 o-medium--4 u-no-gutters\">\n            <form novalidate action=\"#\" method=\"post\" class=\"c-form\">\n                <div class=\"c-form__field\">\n                    <select name=\"shipping-country-select\" id=\"shipping-country-select\" class=\"c-form__select js-shipping-country-select\">\n                         ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"internationalShippingData");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("country", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                            <option ";
if(runtime.memberLookup((t_4),"country") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"selectedCountry")),"country")) {
output += "selected";
;
}
output += " value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"country"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"country"), env.opts.autoescape);
output += "</option>\n                         ";
;
}
}
frame = frame.pop();
output += "\n                    </select>\n                </div>\n            </form>\n        </div>\n    </div>\n\n    ";
env.getTemplate("intl-shipping-information-table.j2", false, "help/templates/eu-shipping-information-table.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/eu-shipping-information-table.j2"] , dependencies)